import moment from 'moment'

export const DATE_WITHOUT_TIME_FORMAT = 'MM/DD/YYYY'

export type IInputDateType = number | string | Date | moment.Moment | null

export const formatDateWithoutTime = (date: IInputDateType) => {
  if (!moment(date).isValid()) {
    return ''
  }
  return typeof date === 'string' && /\d+Z$/i.test(date)
    ? moment(date).utcOffset(0, false).format(DATE_WITHOUT_TIME_FORMAT)
    : moment(date).format(DATE_WITHOUT_TIME_FORMAT)
}
